module.exports = __webpack_public_path__ + "static/media/paymentAccepted.424ec0ed.svg";